import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
  message,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  useGetMasterDistrict,
  useGetMasterProvince,
} from "hooks/useMasterData";
import { MasterDistrictData, MasterProvinceData } from "services/interface";
import { useCreateDeliveryPoint, useGetDeliveryPoint } from "hooks/useShipping";
import DeliveryList from "./DeliveryList";
import { useAppSelector } from "store";
import { useQueryClient } from "@tanstack/react-query";

const { Option } = Select;

const SettingDeliveryPoint = () => {
  const navigate = useNavigate();

  const contact = useAppSelector((state) => state.auth.contact);

  const queryClient = useQueryClient();

  const [province, setProvince] = useState<MasterProvinceData[]>([]);
  const [district, setDistrict] = useState<MasterDistrictData[]>([]);

  const [limit, setLimit] = useState<number>(10);
  const [offset, setOffset] = useState<number>(0);

  const [showParking, setShowParking] = useState<boolean>(false);

  const { mutate: CreateDeliveryPoint } = useCreateDeliveryPoint();

  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  const [search, setSearch] = useState<string>("");

  const [formModal] = Form.useForm();

  const { data, isLoading, refetch } = useGetDeliveryPoint({
    district_id: districtId,
    province_id: provinceId,
    limit: limit,
    offset: offset,
    search: search,
    //factory_id: contact?.id || "",
  });

  const { data: masterProviceData, isLoading: proviceLoading } =
    useGetMasterProvince();

  useEffect(() => {
    if (masterProviceData) {
      setProvince(masterProviceData);
    }
  }, [masterProviceData]);

  const childrenProvince: React.ReactNode[] = [];
  province?.map((item) => {
    childrenProvince.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterDistrictData, isLoading: districtLoading } =
    useGetMasterDistrict(provinceId);

  useEffect(() => {
    if (masterDistrictData) {
      setDistrict(masterDistrictData);
    }
  }, [masterDistrictData]);

  const childrenDistrict: React.ReactNode[] = [];
  district?.map((item) => {
    childrenDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const onCloseModal = () => {
    setShowParking(false);
  };

  const onFinishModal = (values: any) => {
    CreateDeliveryPoint(
      {
        factory_id: contact?.id || "",
        name: values.name,
        district_id: values.district,
        province_id: values.province,
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("สร้างสำเร็จ");
            formModal.setFieldValue("name", "");
            onCloseModal();
            queryClient.refetchQueries({
              queryKey: ["deliveryPoint"],
              type: "all",
            });
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/setting");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>จัดการจุดจอด</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <>
              <TitleWrapper>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 16,
                    width: "100%",
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      gap: 16,
                    }}
                  >
                    <Select
                      value={provinceId === 0 ? undefined : provinceId}
                      style={{ maxWidth: "25%", width: "100%" }}
                      showSearch
                      allowClear
                      placeholder="จังหวัด"
                      optionFilterProp="children"
                      onChange={(value) => {
                        if (value) {
                          setProvinceId(value);
                          formModal.setFieldsValue({ province: value });
                          formModal.setFieldsValue({ district: undefined });
                          setDistrictId(0);
                          setLimit(10);
                          setOffset(0);
                        } else {
                          setProvinceId(0);
                          setDistrictId(0);
                          setLimit(10);
                          setOffset(0);
                          formModal.setFieldsValue({ province: undefined });
                          formModal.setFieldsValue({ district: undefined });
                        }
                      }}
                      notFoundContent={
                        proviceLoading ? <Spin size="small" /> : null
                      }
                      loading={proviceLoading}
                    >
                      {childrenProvince}
                    </Select>

                    <Select
                      value={districtId === 0 ? undefined : districtId}
                      showSearch
                      allowClear
                      style={{ maxWidth: "25%", width: "100%" }}
                      placeholder="อำเภอ"
                      optionFilterProp="children"
                      onChange={(value) => {
                        if (value) {
                          console.log("value--->", value);
                          setDistrictId(value);
                          formModal.setFieldsValue({ district: value });
                          setLimit(10);
                          setOffset(0);
                        } else {
                          setDistrictId(0);
                          formModal.setFieldsValue({ district: undefined });
                          setLimit(10);
                          setOffset(0);
                        }
                      }}
                      notFoundContent={
                        districtLoading ? <Spin size="small" /> : null
                      }
                      loading={districtLoading}
                    >
                      {childrenDistrict}
                    </Select>
                    <Button
                      type="default"
                      onClick={() => {
                        setProvinceId(0);
                        setDistrictId(0);
                        formModal.setFieldsValue({ province: undefined });
                        formModal.setFieldsValue({ district: undefined });
                      }}
                    >
                      ล้างการค้นหา
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowParking(true);
                      }}
                    >
                      เพิ่มจุดส่งสินค้า
                    </Button>
                    <Modal
                      title="เพิ่มจุดส่งสินค้า"
                      open={showParking}
                      maskClosable={false}
                      onCancel={() => {
                        onCloseModal();
                      }}
                      // onOk={() => form.submit()}
                      style={{ top: 20 }}
                      footer={[
                        <Button key="back" onClick={() => onCloseModal()}>
                          ยกเลิก
                        </Button>,
                        <Button
                          key="submit"
                          type="primary"
                          onClick={() => formModal.submit()}
                        >
                          บันทึก
                        </Button>,
                      ]}
                    >
                      <WrapperAll>
                        <Form form={formModal} onFinish={onFinishModal}>
                          <Form.Item
                            labelAlign="left"
                            label="ชื่อจุดจอด"
                            name="name"
                            rules={[
                              {
                                required: true,
                                message: "กรุณากรอกชื่อจุดจอด",
                              },
                            ]}
                          >
                            <Input
                              placeholder="ชื่อจุดจอด"
                              size="small"
                              autoComplete="off"
                            />
                          </Form.Item>

                          <Form.Item
                            label="จังหวัด"
                            className="form-transport"
                            name="province"
                            required
                            rules={[
                              {
                                required: true,
                                message: "กรุณาเลือกจังหวัด",
                              },
                            ]}
                          >
                            <Select
                              style={{ width: "100%", marginBottom: 12 }}
                              showSearch
                              placeholder="จังหวัด"
                              optionFilterProp="children"
                              onChange={(value) => {
                                setProvinceId(value);
                                formModal.setFieldsValue({
                                  district: undefined,
                                });
                              }}
                              notFoundContent={
                                proviceLoading ? <Spin size="small" /> : null
                              }
                              loading={proviceLoading}
                            >
                              {childrenProvince}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label="อำเภอ"
                            className="form-transport"
                            name="district"
                            required
                            rules={[
                              {
                                required: false,
                                message: "กรุณาเลือกอำเภอ",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              style={{ width: "100%" }}
                              placeholder="อำเภอ"
                              optionFilterProp="children"
                              onChange={(value) => {
                                setDistrictId(value);
                              }}
                              notFoundContent={
                                districtLoading ? <Spin size="small" /> : null
                              }
                              loading={districtLoading}
                            >
                              {childrenDistrict}
                            </Select>
                          </Form.Item>
                        </Form>
                      </WrapperAll>
                    </Modal>
                  </div>
                </div>
              </TitleWrapper>

              <DeliveryList
                data={data?.data}
                refetch={refetch}
                limit={limit}
                offset={offset}
                setLimit={setLimit}
                setOffset={setOffset}
              />
            </>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SettingDeliveryPoint;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
`;
